/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Category_Defaultassignee1Inputs */

const en_cases_settings_category_defaultassignee1 = /** @type {(inputs: Cases_Settings_Category_Defaultassignee1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default assignee`)
};

/**
* | output |
* | --- |
* | "Default assignee" |
*
* @param {Cases_Settings_Category_Defaultassignee1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_category_defaultassignee1 = /** @type {((inputs?: Cases_Settings_Category_Defaultassignee1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_Defaultassignee1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_defaultassignee1(inputs)
});
export { cases_settings_category_defaultassignee1 as "cases_settings_category_defaultAssignee" }